/**
 * Exporta una lista de reservaciones a CSV (UTF-8 BOM para Excel).
 */
import { todayLocal } from './format';

const HEADERS = [
  'Codigo', 'Cliente', 'WhatsApp', 'Correo',
  'Adultos', 'Ninos', 'Bebes', 'Total pax',
  'Paquete', 'Fecha salida', 'Hora salida',
  'Precio total', 'Saldo pendiente', 'Estado', 'Canal',
  'Agencia', 'Comision $', 'Comision %',
  'Notas', 'Creada',
];

const esc = (v) => {
  if (v == null) return '';
  const s = String(v);
  if (s.includes(',') || s.includes('"') || s.includes('\n')) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
};

const fmtFecha = (s) => {
  if (!s) return '';
  try { return new Date(s).toLocaleDateString('es-CO', { day: '2-digit', month: '2-digit', year: 'numeric' }); }
  catch { return ''; }
};

export function exportarReservasCSV(rows, nombreArchivo = `reservas-${todayLocal()}.csv`) {
  const csvRows = rows.map(r => [
    r.codigo_reserva, r.nombre_cliente, r.numero_whatsapp, r.correo,
    r.adultos, r.ninos, r.bebes, r.total_pasajeros,
    r.paquete_nombre || r.alquiler_nombre || '',
    fmtFecha(r.salida_fecha), r.salida_hora ? String(r.salida_hora).slice(0, 5) : '',
    r.precio_total, r.saldo_pendiente, r.estado, r.canal_reserva,
    r.agencia_nombre || '', r.comision_valor || '', r.comision_porcentaje || '',
    r.notas || '', fmtFecha(r.created_at),
  ].map(esc).join(','));

  const csv = '﻿' + [HEADERS.join(','), ...csvRows].join('\n');  // BOM UTF-8
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nombreArchivo;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
  return rows.length;
}
